import backgroundImg from '@assets/web-v3-images/ui-3-popup.png';
import imgExit from '@assets/web-v3-images/icons/exits.png';
import Popups from '..';

//UI-3 dùng cho các popup mua trò chơi, mời theo dõi mạng xh, rút LP thành công, cảnh bảo Lp hết hạn.....
export default function ActionSuccessPopup({
	open, onOpenChange, title = 'Demo', children, hiddenIconExit = false
}) {
	return (
		<Popups
			open={open}
			onOpenChange={onOpenChange}
			className="!bg-transparent !shadow-none !p-0 !w-[90vw]
			!max-w-[550px]"
		>
			<div className="flex flex-col w-full relative">
				{!hiddenIconExit &&
					<img src={imgExit} className="w-[10%] h-auto absolute top-[0%] right-[7px] btn-click-active" onClick={() => onOpenChange(!open)} />
				}
				<div
					className="w-full min-h-[400px] sm:min-h-[600px]"
					style={{
						backgroundImage: `url(${backgroundImg})`,
						backgroundPosition: "bottom center",
						backgroundRepeat: 'no-repeat',
						backgroundSize: "100% 100%",
					}}
				>
					{children}
				</div>
			</div>
		</Popups>
	)
}
